"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _errors = require('shared/errors');

// Neither platform's fetch has a timeout of its own (React Native passes 0,
// which OkHttp treats as "never"), so a stalled or trickling upload would
// otherwise spin forever. Allow a minute plus 1 s per 25 KB (a 3.9 MB photo
// gets 3½ minutes, enough at ~18 KB/s), capped so a huge file still fails in
// bounded time.
// The largest file anyone can send: the server's cap on one direct upload
// (bloom.MaxDirectUploadBytes in the backend, 2 GiB). Users see it as "2 GB".
// Checked before an upload starts, whichever path would carry it.
 const MAX_UPLOAD_BYTES = 2 * 1024 ** 3; exports.MAX_UPLOAD_BYTES = MAX_UPLOAD_BYTES

 const UPLOAD_TOO_LARGE_MESSAGE = 'This file is too large to send. The limit is 2 GB.'; exports.UPLOAD_TOO_LARGE_MESSAGE = UPLOAD_TOO_LARGE_MESSAGE

 class UploadTooLargeError extends Error {
  constructor () {
    super('Upload is too large')
    this.name = 'UploadTooLargeError'
  }
} exports.UploadTooLargeError = UploadTooLargeError;

 const isUploadTooLargeSize = (size) =>
  typeof size === 'number' && size > exports.MAX_UPLOAD_BYTES; exports.isUploadTooLargeSize = isUploadTooLargeSize

// Our own check, or the server's refusal (StartUpload's `upload is too large`).
 const isUploadTooLarge = (err) =>
  err instanceof UploadTooLargeError ||
  (!!err && typeof err === 'object' && (err ).Error === 'upload is too large'); exports.isUploadTooLarge = isUploadTooLarge

const UPLOAD_TIMEOUT_BASE_MS = 60000
const UPLOAD_TIMEOUT_MS_PER_25KB = 1000
 const UPLOAD_TIMEOUT_MAX_MS = 20 * 60000; exports.UPLOAD_TIMEOUT_MAX_MS = UPLOAD_TIMEOUT_MAX_MS

 const getUploadTimeoutMs = (bytes) => {
  const size = typeof bytes === 'number' && Number.isFinite(bytes) && bytes > 0 ? bytes : 0
  return Math.min(
    exports.UPLOAD_TIMEOUT_MAX_MS,
    UPLOAD_TIMEOUT_BASE_MS + Math.ceil(size / 25000) * UPLOAD_TIMEOUT_MS_PER_25KB,
  )
}; exports.getUploadTimeoutMs = getUploadTimeoutMs

// Error text can carry URLs, device paths, file names and keys. Keep the shape
// of the message and drop anything that could identify a file or a person.
 const scrubErrorText = (text) => text
  .replace(/\b[a-z][a-z0-9+.-]*:\/\/\S+/gi, '<url>')
  .replace(/(?:\/[^\s/]+){2,}/g, '<path>')
  .replace(/\b[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}\b/gi, '<id>')
  .replace(/\b[0-9a-f]{16,}\b/gi, '<id>')
  .replace(/\S+@\S+\.\S+/g, '<email>')
  .replace(/\b[\w-]+\.(?:mp4|mov|m4v|jpe?g|png|heic|heif|gif|pdf|m4a)\b/gi, '<file>')
  .slice(0, 300); exports.scrubErrorText = scrubErrorText

const getHttpStatus = (err) => {
  if (!(err instanceof _errors.RestError)) return undefined
  const status = _optionalChain([(err ), 'access', _ => _.response, 'optionalAccess', _2 => _2.status])
  return typeof status === 'number' ? status : undefined
}

// Facts a platform's own check attached to the error it threw (mobile's
// missing-file check: folder kind and ages). Only numbers, booleans and short
// labels are kept, so nothing that names a file can ride along.
const attachedDiagnostics = (err) => {
  const attached = _optionalChain([(err ), 'optionalAccess', _3 => _3.diagnostics])
  if (!attached || typeof attached !== 'object') return {}
  const kept = {}
  for (const [key, value] of Object.entries(attached)) {
    if (typeof value === 'number' || typeof value === 'boolean' ||
      (typeof value === 'string' && /^[a-z_]{1,32}$/.test(value))) kept[key] = value
  }
  return kept
}

 const describeUploadError = (err) => {
  const error = err instanceof Error ? err : new Error(String(err))
  const response = err instanceof _errors.RestError
    ? (err ).response
    : undefined
  return {
    ...attachedDiagnostics(err),
    error_name: error.name || 'Error',
    error_message: exports.scrubErrorText.call(void 0, error.message || ''),
    http_status: getHttpStatus(err),
    // RestFetch reports every non-HTTP failure (connection reset, DNS, abort)
    // as a transient RestError with no status.
    network_error: !!_optionalChain([response, 'optionalAccess', _4 => _4.Transient]) && getHttpStatus(err) === undefined,
  }
}; exports.describeUploadError = describeUploadError
